import React from 'react';
import {FormattedMessage} from 'react-intl';

export default {
  key: 'createUserForm',
  fields: [
    {
      name: 'group',
      type: 'groupDropdown',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline'></i>
            <FormattedMessage id='userManagement.createUser.group' />
          </div>
        ),
        required: true,
        validationRules: [
          {type: 'NotNullOrBlank'}
        ]
      }
    },
    {
      name: 'firstName',
      type: 'text',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline'></i>
            <FormattedMessage id='userManagement.createUser.firstName' />
          </div>
        ),
        required: true,
        validationRules: [
          {type: 'NotNullOrBlank'}
        ]
      }
    },
    {
      name: 'lastName',
      type: 'text',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline'></i>
            <FormattedMessage id='userManagement.createUser.lastName' />
          </div>
        ),
        required: true,
        validationRules: [
          {type: 'NotNullOrBlank'}
        ]
      }
    },
    {
      name: 'email',
      type: 'text',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline'></i>
            <FormattedMessage id='userManagement.createUser.email' />
          </div>
        ),
        required: true,
        validationRules: [
          {type: 'EmailFormat'},
          {type: 'NotNullOrBlank'}
        ]
      }
    },
    {
      name: 'username',
      type: 'text',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline'></i>
            <FormattedMessage id='userManagement.searchPanel.username' />
          </div>
        ),
        required: true,
        validationRules: [
          {type: 'NotNullOrBlank'}
        ]
      }
    },
    {
      name: 'password',
      type: 'text',
      props: {
        password: true,
        label: (
          <div>
            <i className='asterisk icon inline'></i>
            <FormattedMessage id='userManagement.createUser.password' />
          </div>
        ),
        required: true,
        validationRules: [
          {type: 'NotNullOrBlank'}
        ]
      }
    },
    {
      name: 'passwordConfirmation',
      type: 'text',
      props: {
        password: true,
        label: (
          <div>
            <i className='asterisk icon inline'></i>
            <FormattedMessage id='userManagement.createUser.passwordConfirmation' />
          </div>
        ),
        required: true,
        validationRules: [
          {type: 'NotNullOrBlank'}
        ]
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/CreateUserModal/createUserFormConfig.jsx